export default __webpack_public_path__ + "static/media/Ballroll_00305.0e40e9e5.png";